/**
 * Created by wjjn3481 on 2017/7/20.
 */
import Vue from 'vue'
import axios from 'axios'
import store from 'src/store'

export default [{
    path: '/login',
    name: 'login',
    meta: {
        auth: false
    },
    beforeEnter(to, from, next) {
        axios.get('/sessionObj.api', {
            'X-loadingOff': false
        }).then(res => {
            if (res.result.sysConfig && res.result.user) {
                // const menu = res.result.sysConfig.menu.find(menu => menu.text === '简历查重')
                // if(menu) {
                //   menu.value = 'resumeDuplication'
                // }
                // console.log(res.result.sysConfig.menu)
                const { needEditScoreTypeIds = [], needEntryWritePrject = [] } = res.result || {}
                store.commit('APP_IN', res.result.sysConfig)
                store.commit('USER_SIGN_IN', res.result.user)
                store.commit('NEED_IDS', {
                    needEditScoreTypeIds,
                    needEntryWritePrject,
                })
                next({
                    path: to.query.from || '/'
                })
            } else {
                store.commit('USER_SIGN_OUT')
                next()
            }
        }).catch(() => {
            store.commit('USER_SIGN_OUT')
            next()
        })
    },
    components: require('views/login/login')
}, { // 首页
    path: '/index',
    name: 'index',
    meta: {
        menuIcon: 'el-icon-my-shouye'
    },
    components: require('views/index/index')
}, {
    path: '/resumeDuplication',
    name: 'resumeDuplication',
    meta: {
        menuIcon: 'el-icon-my-jianlichi'
    },
    components: require('views/resumeDuplication')
}, { // 简历列表
    path: '/resume',
    name: 'resumeList',
    meta: {
        menuIcon: 'el-icon-my-jianlichi'
    },
    components: require('views/resume/resumeList')
}, { // 简历详情
    path: '/resume/detail/:id/:phase',
    name: 'resumeDetail',
    components: require('views/resumeDetail/resumeDetail')
}, { // 面试安排（单个）
    path: '/arrangement/:id',
    name: 'singleArrangement',
    components: require('views/arrangement/arrangement')
}, { // 简历评价
    path: '/evaluationResume/:id',
    name: 'evaluationResume',
    components: require('views/evaluation/resume')
}, { // 面试评价
    path: '/evaluation/:id',
    name: 'evaluation',
    components: require('views/evaluation/society')
}, { // 评分表
    path: '/scoreTips',
    name: 'scoreTips',
    meta: {
        template: 'full'
    },
    components: require('views/evaluation/score-tips/score-tips')
}, { // 面试安排（多个）
    path: '/arrangements/:ids',
    name: 'multiArrangement',
    components: require('views/arrangement/arrangements')
}, { // 面试阶段
    path: '/interview/:id',
    name: 'interviewList',
    meta: {
        activeMenuItem: 'interviewList',
        oneToMore: true,
        menuIcon: 'el-icon-my-mianshi'
    },
    components: require('views/interview/interviewList')
}, {
    path: '/salary',
    name: 'paymentList',
    meta: {
        menuIcon: 'el-icon-my-mianshipinggu'
    },
    components: require('views/salary/salaryList')
}, {
    path: '/salary/detail/:id',
    name: 'paymentDetail',
    components: require('views/evaluation/salary')
}, {
    path: '/salary/rules',
    name: 'paymentRules',
    components: require('views/salary/salaryRuleList')
}, {
    path: '/salary/rules/:id',
    name: 'paymentRuleDetail',
    components: require('views/salary/salayRuleDetail')
}, { // 入职阶段
    path: '/entry',
    name: 'entryList',
    meta: {
        menuIcon: 'el-icon-my-ruzhi'
    },
    components: require('views/entry/entryList')
}, { // 笔试阶段
    path: '/written',
    name: 'writtenList',
    meta: {
        menuIcon: 'el-icon-my-bishi'
    },
    components: require('views/written/writtenList')
}, { // 笔试个人详情
    path: '/written/detail/:id',
    name: 'writtenPersonDetail',
    meta: {
        menuIcon: 'el-icon-my-bishi'
    },
    components: require('views/written/writtenPersonDetail')
}, { // 试题预览
    path: '/written/topic/:id',
    name: 'examTopic',
    components: require('views/written/examTopic')
}, { // 笔试安排阶段
    path: '/written/arrangement/:ids',
    name: 'writtenArrangement',
    components: require('views/written/writtenArrangement')
}, { // 已安排笔试详情
    path: '/written/exam/detail/:id',
    name: 'writtenExamDetail',
    components: require('views/written/writtenArrangementDetail')
}, { // 已安排笔试列表
    path: '/written/exam/list',
    name: 'writtenExamList',
    components: require('views/written/writtenArrangementList')
}, { // 笔试推荐阶段
    path: '/written/recommend/:ids',
    name: 'writtenRecommend',
    components: require('views/written/writtenRecommend')
}, { // 职位管理
    path: '/position/manager',
    name: 'positionManager',
    meta: {
        menuIcon: 'el-icon-my-zhaopinguanli'
    },
    components: require('views/position/positionList')
}, { // 职位审核
    path: '/position/review',
    name: 'positionReview',
    components: require('views/position/reviewList')
}, { // 内推管理
    path: '/position/recommend',
    name: 'positionRecommend',
    components: require('views/position/recommendList')
}, { // 更多
    path: '/more',
    name: 'more',
    meta: {
        menuIcon: 'el-icon-my-gengduo'
    },
    components: require('views/more/entrance')
}, { // 供应商管理
    path: '/supplier',
    name: 'supplier',
    components: require('views/supplier/supplierList'),
    beforeEnter: (to, from, next) => {
        axios.get('/supplier/getAllSupplier.api', {
            'X-cacheable': true
        }).then(res => {
            to.meta.companyList = res.result.list
            next()
        })
    }
}, { // 供应商详情
    path: '/supplier/users',
    name: 'supplierUsers',
    components: require('views/supplier/supplierUsers'),
    beforeEnter: (to, from, next) => {
        axios.get('/supplier/getAllSupplier.api', {
            'X-cacheable': true
        }).then(res => {
            to.meta.companyList = res.result.list
            next()
        })
    }
}, { // 供应商详情
    path: '/supplier/statistic',
    name: 'supplierStatistic',
    components: require('views/supplier/statistic')
}, { // 伯乐管理
    path: '/bole',
    name: 'boleList',
    components: require('views/more/bole/boleList')
}, { // 内推管理
    path: '/project',
    name: 'project',
    components: require('views/position/recommendList')
}, { // 学校档位管理
    path: '/school/level',
    name: 'schoolLevel',
    components: require('views/more/schoolLevel')
}, { // 项目查看权限管理
    path: '/permission/project',
    name: 'projectPermission',
    components: require('views/permission/projectList')
}, { // 模版管理
    path: '/message/email',
    name: 'emailTpl',
    components: require('views/message/emailTplList')
}, { // 模版管理
    path: '/message/emailHistory',
    name: 'emailHistory',
    meta: {
        menuIcon: 'el-icon-my-youjian'
    },
    components: require('views/message/emailHistoryList')
}, {
    path: '*',
    name: 'defaultView',
    redirect: {
        name: 'index'
    }
}]


// WEBPACK FOOTER //
// ./src/router/routes.js